import { trpc } from '../../../utils/trpc'

export function usePointMultipliers(onlyRunning: boolean = false) {
  return trpc.useQuery(['pointsMultiplier.find-all', { onlyRunning }], {
    enabled: true,
  })
}
